import React from "react";
import ReactDOM from "react-dom/client";
import MainRouter from "./routes/MainRouter";
import "./index.scss";
import "animate.css";

// PrimeReact core
import "primereact/resources/themes/lara-light-blue/theme.css"; // o cualquier otro tema
import "primereact/resources/primereact.min.css";

// PrimeIcons (para íconos como botones o menús)
import "primeicons/primeicons.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    // StrictMode desactivado temporalmente para compatibilidad con react-beautiful-dnd
    // <React.StrictMode>
    <MainRouter></MainRouter>
    // </React.StrictMode>
);
